<div
  [attr.data-automation]="dataAutomation()"
  class="my-3 row form-group"
  [hidden]="state.hidden"
  [ngClass]="{
    'has-feedback': hasFeedback(),
    'ziro-forms-error': validationState === ValStates.INVALID,
    'ziro-forms-warning': validationState === ValStates.WARNING,
  }"
>
  @if (config?.label) {
    <label
      class="col-form-label"
      [ngClass]="{
        'ziro-forms-label': inlineLabel(),
        'col-12 pb-0': !inlineLabel(),
      }"
    >
      @if (config?.required) {
        <span class="text-danger ziro-forms-asterisk">*</span>
      }
      <span>{{ getLabel() | translate }}</span>
    </label>
  }

  <ziro-time-ranges-form
    [ngClass]="{ 'col-12': !inlineLabel(), 'col-9 mb-3': inlineLabel() }"
    [upstreamEntity]="upstreamEntity"
    [isFormSubmitted]="isFormSubmitted"
    [dataAutomation]="dataAutomation() + '-form'"
    [hideDelete]="hideDelete()"
    (ziroFormsUpdate$)="onFormUpdate($event)"
    (rangeDelete)="updateSelf(fieldData)"
    class="mb-3"
  ></ziro-time-ranges-form>

  @if (canAddRanges()) {
    <div class="text-end">
      <ziro-button
        [label]="
          'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.add_slot' | translate
        "
        [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
        [icon]="ZiroIcons.ADD"
        [buttonSize]="ButtonSizes.SMALL"
        (clicked)="addSlot()"
        dataAutomation="add-time-range-button"
      ></ziro-button>
    </div>
  }
  @if (upstreamEntity.length === 0) {
    <div
      [ngClass]="{
        'has-feedback': hasFeedback(),
        'ziro-forms-error': validationState === ValStates.INVALID,
      }"
      class="ziro-forms-ranges-validation-message"
      [hidden]="!hasFeedback()"
      data-automation="ziro-forms-validation-message"
      [innerHTML]="validationMessage?.content | escapeHtml: validationMessage?.params"
    ></div>
  }
</div>
